import React from "react"

const Title = ({ title, border, align="lg:text-left" }) => (
  <div className={`border-solid lg:${border} border-blue-200 pl-2 w-full`}>
    <h1 className={`text-4xl font-bold text-center ${align} text-gray-700 uppercase tracking-widest`}>{title}</h1>
  </div>
)

export default Title